































import {
  defineComponent,
  computed,
  ref,
  onMounted
} from '@nuxtjs/composition-api';
import axios from 'axios';
export default defineComponent({
  name: 'VideoFacade',
  props: {
    src: {
      type: String,
      default: ''
    },
    wrap: {
      type: Boolean,
      default: true
    },
    poster: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const type = computed(() => {
      if (props.src.indexOf('vimeo') > -1) return 'vimeo';
      if (props.src.indexOf('youtu') > -1) return 'youtube';

      return '';
    })
    const posterImg = ref('')
    const frameLoaded = ref(false);
    const adjustedSrc = ref(props.src)

    const getId = () => {
      if (type.value === 'youtube') {
        const reg = new RegExp(/(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        const matches = props.src.match(reg);
        if (matches[1]) {
          return matches[1]
        }
      }
      if (type.value === 'vimeo') {
        const reg = new RegExp(/\/videos\/|album\/[\d+]\/video\/|video\/([\d]+)/);
        const matches = props.src.match(reg);
        if (matches[1]) return matches[1]
      }

      return '';
    }

    const getPosterImg = async () => {
      if (props.poster) return props.poster;
      const id = getId();
      if (!id) {
        return ''
      }
      if (type.value === 'youtube') {
        return 'https://img.youtube.com/vi/' + id + '/0.jpg';
      }
      if (type.value === 'vimeo') {
        const result = await axios.get('https://vimeo.com/api/v2/video/' + id + '.json');
        const thumbnail = result.data[0].thumbnail_large;
        const imgId = (thumbnail.substr(thumbnail.lastIndexOf("/") + 1)).split("_")[0];
        return `https://i.vimeocdn.com/video/${imgId}.webp?mw=1100&mh=619&q=70`
      }
      return ''
    }

    onMounted(async() => {
      posterImg.value = await getPosterImg();

      if (props.src) {
        const srcUrl = new URL(props.src);
        adjustedSrc.value = type.value === 'youtube' 
          ? `https://www.youtube.com/embed/${getId()}?autoplay=1` 
          : `${srcUrl.origin}${srcUrl.pathname}${srcUrl.search ? srcUrl.search + '&autoplay=1' : '?autoplay=1'}`
      }
    })

    const loadFrame = () => {
      if (!frameLoaded.value) {
        frameLoaded.value = true
      }
    }

    return {
      posterImg,
      frameLoaded,
      loadFrame,
      adjustedSrc
    }
  },
  head () {
    if (this.type === 'vimeo') {
      return {
        link: [
          { rel: 'preconnect', href: 'https://i.vimeocdn.com' },
          { rel: 'preconnect', href: 'https://f.vimeocdn.com' },
          { rel: 'preconnect', href: 'https://player.vimeo.com' }
        ]
      }
    }
    if (this.type === 'youtube') {
      return {
        link: [
          { rel: 'preconnect', href: 'https://youtube.com' },
          { rel: 'preconnect', href: 'https://www.google.com' }
        ]
      }
    }
  }
})
